import React, { useEffect } from 'react'
import Banner from '../components/Banner'
import { useDataContext } from '../context/DataContext';

const PrivacyPolicy = () => {
  const { privacyPolicy, loading, error, fetchPrivacy } = useDataContext();

  useEffect(() => {
    fetchPrivacy()
  }, []);

  return (
    <main id="terms-condition">

      <Banner img="assets/yachtimages/07.webp" text="Privacy Policy" />

      <section className="gap container">
        <h2>{privacyPolicy && privacyPolicy[0].title}</h2>
        {privacyPolicy && <div dangerouslySetInnerHTML={{ __html: privacyPolicy[0].description }} />}

      </section>

    </main>
  )
}

export default PrivacyPolicy